var account = "Účet";
var accountSettings = "Nastavení účtu";
var charging = "Nabíjení";
var contactInfo = "Kontaktní údaje";
var dashboard = "Dashboard";
var home = "Domů";
var myProducts = "Moje produkty";
var orderHistory = "Historie objednávek";
var paymentMethod = "Platební metoda";
var profileSettings = "Nastavení profilu";
var referAndEarn = "Doporučte a získejte odměnu";
var signOut = "Odhlásit se";
var cs_CZ = {
	account: account,
	accountSettings: accountSettings,
	charging: charging,
	contactInfo: contactInfo,
	dashboard: dashboard,
	home: home,
	myProducts: myProducts,
	orderHistory: orderHistory,
	paymentMethod: paymentMethod,
	profileSettings: profileSettings,
	referAndEarn: referAndEarn,
	signOut: signOut
};

export { account, accountSettings, charging, contactInfo, dashboard, cs_CZ as default, home, myProducts, orderHistory, paymentMethod, profileSettings, referAndEarn, signOut };
